import Geolocation from 'ol/Geolocation'
import Point from 'ol/geom/Point'
import Feature from 'ol/Feature'
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style'

const geoLocationLayer = (projection, positionCallback) => {
  const geolocation = new Geolocation({
    trackingOptions: {
      enableHighAccuracy: true
    },
    // take the projection to use from the map's view
    projection
  })

  geolocation.setTracking(true)

  geolocation.on('change', function (evt) {
    positionCallback(geolocation.getPosition())
    // window.console.log(geolocation.getPosition())
  })

  geolocation.on('error', function (error) {
    console.log(error)
    positionCallback(null)
  })

  const accuracyFeature = new Feature()
  geolocation.on('change:accuracyGeometry', function () {
    accuracyFeature.setGeometry(geolocation.getAccuracyGeometry())
  })
  accuracyFeature.setId('accuracyFeature')

  const positionFeature = new Feature()
  positionFeature.setId('positionFeature')
  positionFeature.setProperties({ type: 'position' })
  positionFeature.setStyle(new Style({
    image: new CircleStyle({
      radius: 8,
      fill: new Fill({
        color: '#3f8299'
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 2
      })
    })
  }))

  geolocation.on('change:position', function () {
    const coordinates = geolocation.getPosition()
    positionFeature.setGeometry(coordinates
      ? new Point(coordinates) : null)
  })

  return new VectorLayer({
    className: 'geoLocationLayer',
    zIndex: 2,
    source: new VectorSource({
      features: [accuracyFeature, positionFeature]
    })
  })
}

export default geoLocationLayer
